import { useReducer } from 'react';
export const usePartial = <T>(initialState: T): [T, (update: Partial<T>) => void] => {
  const partialReducer = (state: T, update: Partial<T>) => {
    return { ...state, ...update };
  };
  const [state, dispatch] = useReducer(partialReducer, initialState);
  const setPartial = (update: Partial<T>) => {
    dispatch(update);
  };
  return [state, setPartial];
};
